import { render, staticRenderFns } from "./SetForm.vue?vue&type=template&id=622c0c29&"
import script from "./SetForm.vue?vue&type=script&lang=js&"
export * from "./SetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports